import { workoutsApi } from '../../../../common/networking/workouts'
import { reportEmbeddedFailure } from '../../../../common/utility/embeddedErrorReporter'
import { AppThunk, RootState } from '../../../store'
import { getWorkoutFailure, getWorkoutPending, getWorkoutSuccess } from '.'

let latestWorkoutRequestId = 0

export const getWorkout =
  (workoutId: number): AppThunk =>
  async (dispatch, getState) => {
    const requestId = ++latestWorkoutRequestId
    const state = getState() as RootState
    const authToken = state.auth.token
    dispatch(getWorkoutPending(true))
    try {
      const { fetchWorkout } = workoutsApi()
      const response = await fetchWorkout({ workoutId, authToken })

      if (requestId !== latestWorkoutRequestId) return

      dispatch(getWorkoutSuccess(response))
    } catch (error: any) {
      if (requestId !== latestWorkoutRequestId) return

      reportEmbeddedFailure({
        category: 'workout_data',
        message: error instanceof Error ? error.message : String(error),
        name: 'WorkoutDetailLoadError',
        workoutId,
      })
      dispatch(getWorkoutFailure(error.toString()))
    }
  }
